import EffectAmount from '@/roc/effects/EffectAmount';
import ProductionOutput from '@/roc/effects/Production/ProductionOutput';
class ChestItem extends EffectAmount {
    __outputType;
    __chance;
    constructor(calc, amount, outputType = null, chance = null) {
        super(calc, amount);
        this.__outputType = outputType;
        this.__chance = chance;
    }
    withOutput(output) {
        return new ChestItem(this.__calc, this.__amount, output, this.__chance);
    }
    withChance(chance) {
        return new ChestItem(this.__calc, this.__amount, this.__outputType, chance);
    }
    format(amount) {
        if (!this.__outputType) {
            return '';
        }
        const o = new ProductionOutput(this.__calc, this.__amount, this.__outputType);
        return o.format(amount) + ' (' + this.__chance + '%)';
    }
}
export default ChestItem;
